import axios from 'axios';

const api = axios.create({baseURL: 'https://wyd.raidhut.com.br/raid/'});
const root = axios.create({baseURL: window.location.href.split('?')[0]});
const viacep = axios.create({baseURL: 'https://viacep.com.br/ws/',withCredentials: false,crossdomain: true});
const boacompra = axios.create({baseURL: 'https://billing.boacompra.com/'});

export {api,root,viacep,boacompra};